var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { singleton } from "tsyringe";
import { DateRange, makeImmutable, RDate } from "../core";
import { Holidays } from "../collections";
import { ChannelScheduleParser, } from "./ChannelScheduleParser";
let RestaurantHoursParser = class RestaurantHoursParser {
    constructor(channelScheduleParser) {
        this.channelScheduleParser = channelScheduleParser;
        makeImmutable(this);
    }
    parse(response, timezone) {
        return {
            channels: {
                opening: this.channelScheduleParser.parse(response.restaurant_hours),
                online: this.channelScheduleParser.parse(response.online_hours),
                phone: this.channelScheduleParser.parse(response.phone_hours),
            },
            channelDayHours: {
                opening: response.restaurant_hours.map((day) => day.hours),
                online: response.online_hours.map((day) => day.hours),
                phone: response.phone_hours.map((day) => day.hours),
            },
            holidays: Holidays.create(timezone, this.holidayInfos(response.holidays)),
            holidayViews: response.holidays.map((holiday) => this.holidayView(holiday, timezone)),
            upcomingHolidays: response.upcoming_holidays,
        };
    }
    holidayInfos(holidays) {
        return holidays.map((holiday) => ({
            startDate: holiday.start_date,
            endDate: holiday.end_date,
            from: holiday.time_range.start,
            to: holiday.time_range.stop,
        }));
    }
    holidayView(holiday, timezone) {
        return {
            dates: DateRange.fromDates({
                begin: RDate.fromLocalTimeString(holiday.start_date, timezone).startOfDay(),
                end: RDate.fromLocalTimeString(holiday.end_date, timezone).endOfDay(),
            }),
            hours: holiday.hours,
            info: holiday.info,
        };
    }
};
RestaurantHoursParser = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof ChannelScheduleParser !== "undefined" && ChannelScheduleParser) === "function" ? _a : Object])
], RestaurantHoursParser);
export { RestaurantHoursParser };
